import { render, staticRenderFns } from "./BlockFeature.vue?vue&type=template&id=e869a936&scoped=true&"
import script from "./BlockFeature.vue?vue&type=script&lang=js&"
export * from "./BlockFeature.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeature.vue?vue&type=style&index=0&id=e869a936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e869a936",
  null
  
)

export default component.exports